export const STRIPE_CONNECT_SUBCOLLECTION = "stripe";
export const STRIPE_CONNECT_DOC_ID = "connect";

export const STRIPE_TEACHER_DEFAULTS = {
  stripeAccountId: null,
  stripeOnboardingStatus: "not_started",
  chargesEnabled: false,
  payoutsEnabled: false,
  detailsSubmitted: false,
  onboardingUrl: null,
  requirementsCurrentlyDue: [],
  requirementsEventuallyDue: [],
  lastStripeSyncAt: null,
  // Reserved for future Connect fields without changing top-level schema.
  stripeConnectMeta: {},
};

export function getMissingStripeTeacherFields(teacherDoc = {}) {
  const missing = {};

  if (typeof teacherDoc.stripeAccountId === "undefined") missing.stripeAccountId = null;
  if (typeof teacherDoc.stripeOnboardingStatus === "undefined") missing.stripeOnboardingStatus = "not_started";
  if (typeof teacherDoc.chargesEnabled === "undefined") missing.chargesEnabled = false;
  if (typeof teacherDoc.payoutsEnabled === "undefined") missing.payoutsEnabled = false;
  if (typeof teacherDoc.detailsSubmitted === "undefined") missing.detailsSubmitted = false;
  if (typeof teacherDoc.onboardingUrl === "undefined") missing.onboardingUrl = null;
  if (!Array.isArray(teacherDoc.requirementsCurrentlyDue)) missing.requirementsCurrentlyDue = [];
  if (!Array.isArray(teacherDoc.requirementsEventuallyDue)) missing.requirementsEventuallyDue = [];
  if (typeof teacherDoc.lastStripeSyncAt === "undefined") missing.lastStripeSyncAt = null;
  if (
    typeof teacherDoc.stripeConnectMeta === "undefined" ||
    teacherDoc.stripeConnectMeta === null ||
    Array.isArray(teacherDoc.stripeConnectMeta)
  ) {
    missing.stripeConnectMeta = {};
  }

  return missing;
}
